<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-02-10 15:41:26
 * @Description: 设置剖切盒子是否显示
 * @LastEditors: Please set LastEditors
-->
<template>
  <el-card class="h-100 position-absolute" id="clip">
    <div slot="header" class="clearfix">
      <el-row type="flex" align="middle">
        <el-col :span="18">设置剖切盒子</el-col>
        <el-col :span="6" class="tr">
          <span class="iconfont icon-close cur-pointer" @click="closeClip(false)"></span>
        </el-col>
      </el-row>
    </div>
    <el-checkbox-group v-model="clipList" @change="onChange">
      <el-checkbox label="包围盒"></el-checkbox>
      <el-checkbox label="操作轴"></el-checkbox>
    </el-checkbox-group>
  </el-card>
</template>

<script>
import { cilpSetting, cancelClip } from '../js/clip'
export default {
  props: ['clipData'],
  data() {
    return {
      clipList: ['包围盒', '操作轴'],
    }
  },
  methods: {
    onChange(data) {
      window.player.Native.ClipBox.clipObjectSetVisible(
        this.clipData.clipObj,
        this.clipList.includes('包围盒')
      )
      const isShowAxis = this.clipList.includes('操作轴')
      for (let i = 0; i < this.clipData.axisObjs.length; i++) {
        window.player.Native.Axis.setProperties(this.clipData.axisObjs[i], {
          visible: isShowAxis,
        })
      }
    },
    closeClip(val) {
      this.$emit('changeClip', val)
    },
  },
}
</script>
<style lang="scss" scoped>

#clip {
  height: 150px;
  width: 240px;
  left: 6px;
  top: 44px;
  box-shadow: 0px 0px 1px 4px #dcdbdb91;
  border-radius: 4px;
  z-index: 99;
}

</style>
